import { useState } from "react";
import { blogs } from "../data/blogs";
import SEO from "../components/common/SEO";

import BlogsBanner from "../components/blogs/BlogsBanner";
import SearchCategoryFilter from "../components/blogs/SearchCategoryFilter";
import FeaturedBlogs from "../components/blogs/FeaturedBlogs";
import BlogsGrid from "../components/blogs/BlogsGrid";
import Pagination from "../components/blogs/Pagination";
import CTASection from "../components/common/CTASection";

const Blogs = () => {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);

  const blogsPerPage = 6;

  const filteredBlogs = blogs.filter((blog) => {
    const matchesSearch =
      blog.title.toLowerCase().includes(search.toLowerCase());

    const matchesCategory =
      category === "All" ||
      blog.category === category;

    return matchesSearch && matchesCategory;
  });

  const indexOfLastBlog =
    currentPage * blogsPerPage;

  const indexOfFirstBlog =
    indexOfLastBlog - blogsPerPage;

  const currentBlogs =
    filteredBlogs.slice(
      indexOfFirstBlog,
      indexOfLastBlog
    );

  const totalPages = Math.ceil(
    filteredBlogs.length / blogsPerPage
  );

  return (
    <>
      <SEO
        title="Construction Blogs & Real Estate News | AZ Construction"
        description="Read expert articles, construction tips, real estate insights, property investment guides, and industry news from AZ Construction."
        url="https://azconstruction.com/blogs"
      />
      <BlogsBanner />

      <SearchCategoryFilter
        search={search}
        setSearch={setSearch}
        category={category}
        setCategory={setCategory}
      />

      <FeaturedBlogs />

      <BlogsGrid blogs={currentBlogs} />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        paginate={setCurrentPage}
      />

      <CTASection />
    </>
  );
};

export default Blogs;